import { NgModule } from '@angular/core';

import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DatePickerModule } from 'primeng/datepicker';
import { InputNumberModule } from 'primeng/inputnumber';
import { FloatLabelModule } from 'primeng/floatlabel';
import { SplitterModule } from 'primeng/splitter';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TextareaModule } from 'primeng/textarea';
import { TooltipModule } from 'primeng/tooltip';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { SelectButtonModule } from 'primeng/selectbutton';
import { CheckboxModule } from 'primeng/checkbox';
import { TabsModule } from 'primeng/tabs';
import { PopoverModule } from 'primeng/popover';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { MultiSelectModule } from 'primeng/multiselect';
import { ListboxModule } from 'primeng/listbox';
import { ChartModule } from 'primeng/chart';
import { AccordionModule } from 'primeng/accordion';

@NgModule({
  exports: [
    TableModule,
    ButtonModule,
    InputTextModule,
    InputNumberModule,
    DatePickerModule,
    FloatLabelModule,
    SplitterModule,
    AutoCompleteModule,
    TextareaModule,
    TooltipModule,
    IconFieldModule,
    InputIconModule,
    SelectButtonModule,
    CheckboxModule,
    TabsModule,
    PopoverModule,
    OverlayBadgeModule,
    MultiSelectModule,
    ListboxModule,
    ChartModule,
    AccordionModule,
  ]
})
export class PrimengModule {
  constructor() {
  }
}
